import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { SEOService } from '../services/seo/seo-service';

type SeoParams = {
  metaTitle: string;
  metaDescription: string;
  noIndex: boolean | undefined;
  metaKeywords: string | undefined;
};

interface Resolve {
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): any;
}
@Injectable({ providedIn: 'root' })
export class SEOResolver implements Resolve {
  private seoService = inject(SEOService);
  constructor() {}
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const { seoParams } = route.data;

    const seo = seoParams as SeoParams;

    const metaInfo = {
      metaTitle: seo?.metaTitle ?? undefined,
    };

    this.seoService.setMetaTags(metaInfo);
  }
}
